import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'la-delay-button',
  templateUrl: './delay-button.component.html',
  styleUrls: ['./delay-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule],
})
export class DelayButtonComponent {
  @Input() delay = 500;
  @Input() disabled = false;
  @Output() action = new EventEmitter<void>();

  private readonly cd = inject(ChangeDetectorRef);

  private cursor: ReturnType<typeof setTimeout> | undefined;
  private _pending?: boolean;

  get pending(): boolean | undefined {
    return this._pending;
  }

  @Input() set pending(value: boolean) {
    if (value) {
      this._pending = value;
    }

    if (this.cursor) {
      clearTimeout(this.cursor);
    }

    this.cursor = setTimeout(() => {
      this._pending = false;
      clearTimeout(this.cursor);
      this.cursor = undefined;
      this.cd.markForCheck();
    }, this.delay);
  }
}
